(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.home-print-loop').forEach(root => {
    const stage = root.querySelector('.print-home-grid');
    const slides = [...stage.querySelectorAll('.print-card')];
    if (slides.length < 2) return;
    root.classList.add('is-loop');
    const track = document.createElement('div'); track.className = 'home-loop-track';
    const group = document.createElement('div'); group.className = 'home-loop-group';
    slides.forEach(slide => group.append(slide));
    const copy = group.cloneNode(true); copy.setAttribute('aria-hidden', 'true');
    copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
    copy.querySelectorAll('a').forEach(a => { a.tabIndex = -1; });
    track.append(group, copy); stage.replaceChildren(track);
    const play = root.querySelector('[data-play]');
    let paused = reduced.matches, hover = false, visible = false, previous = 0, position = 0, span = 0;
    function label() {
      play.textContent = paused ? 'Play' : 'Pause';
      play.setAttribute('aria-label', (paused ? 'Play ' : 'Pause ') + root.getAttribute('aria-label') + ' scrolling');
    }
    function measure() {
      const count = stage.clientWidth > 900 ? 3 : stage.clientWidth > 600 ? 2 : 1.15;
      root.style.setProperty('--home-card-width', `${(stage.clientWidth - (count - 1) * 24) / count}px`);
      span = group.getBoundingClientRect().width;
      position = span ? stage.scrollLeft % span : 0;
      stage.scrollLeft = position;
    }
    new ResizeObserver(measure).observe(stage);
    play.addEventListener('click', () => { paused = !paused; position = stage.scrollLeft; label(); });
    root.addEventListener('mouseenter', () => { hover = true; });
    root.addEventListener('mouseleave', () => { hover = false; position = stage.scrollLeft; });
    stage.addEventListener('touchstart', () => { paused = true; label(); }, {passive:true});
    stage.addEventListener('scroll', () => { if (paused || hover || root.contains(document.activeElement)) position = stage.scrollLeft; }, {passive:true});
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, {threshold:0.1}).observe(root);
    reduced.addEventListener('change', () => { if (reduced.matches) { paused = true; label(); } });
    function frame(now) {
      const elapsed = previous ? Math.min(now - previous, 64) : 0; previous = now;
      if (!paused && !hover && visible && !document.hidden && !root.contains(document.activeElement) && span > 0) {
        position = (position + elapsed * 0.056) % span;
        stage.scrollLeft = position;
      }
      requestAnimationFrame(frame);
    }
    measure(); label(); requestAnimationFrame(frame);
  });
})();
